<template>
    <ul class="navigation">
        <router-link tag="li" active-class="navigation__active" :to="{name: 'dashboard'}">
            <a>Home</a>
        </router-link>

        <router-link tag="li" active-class="navigation__active" v-if="cropTypeId"
                     :to="{name: 'variety-groups.browse', params: {cropTypeId: cropTypeId}}">
            <a>Variety Groups/ Varieties</a>
        </router-link>

        <router-link tag="li" active-class="navigation__active" :to="{name: 'chemical-targets.browse'}">
            <a>Chemical Targets</a>
        </router-link>

        <router-link tag="li" active-class="navigation__active" :to="{name: 'chemical-classifications.browse'}">
            <a>Chemical Classifications</a>
        </router-link>

        <router-link tag="li" active-class="navigation__active" :to="{name: 'chemical-commercial-variants.browse'}">
            <a>Commercial Chemicals</a>
        </router-link>

        <router-link tag="li" active-class="navigation__active" :to="{name: 'chemical-active-ingredients.browse'}">
            <a>Chemical Active Ingredients</a>
        </router-link>

        <router-link tag="li" active-class="navigation__active" :to="{name: 'countries.browse'}">
            <a>Countries &amp; Regions</a>
        </router-link>

        <router-link tag="li" active-class="navigation__active" :to="{name: 'fertilisers.browse'}">
            <a>Fertilisers</a>
        </router-link>

        <router-link tag="li" active-class="navigation__active" :to="{name: 'fertiliser-additives.browse'}">
            <a>Fertiliser Additives</a>
        </router-link>

        <router-link tag="li" active-class="navigation__active" :to="{name: 'withholding-periods.browse'}">
            <a>Withholding Periods</a>
        </router-link>
    </ul>
</template>

<script>
export default {
  name: 'AssociationAppSidebar',
  props: ['user'],
  apollo: {},
  data() {
    return {
      loading: 0,
    };
  },
  computed: {
    cropTypeId() {
      return this.$path.get(this, 'user.managedAssociation.crop_type_id');
    },
  },
  methods: {
    isActiveItem(url) {
      return this.$route.path.startsWith(url);
    },
  },
};
</script>
